import Vue from 'vue'
import Router, { RawLocation } from 'vue-router'

import { RootState } from '@/store/types'
import Locker from '@/util/Locker'

Vue.use(Router)

export const router = new Router({
    // mode: process.versions && process.versions.electron ? 'hash' : 'history',
    mode: 'hash',
    routes: [
        // {
        //     path: '/',
        //     component: Initialize
        // },
        // ONBOARDING
        {
            name: 'register',
            path: '/register',
            component: () => import('@/components/onboarding/Register.vue')
        },
        {
            name: 'unlock',
            path: '/unlock',
            component: () => import('@/components/onboarding/Unlock.vue')
        },
        {
            name: 'link',
            path: '/link',
            component: () => import('@/components/onboarding/LinkDevice.vue')
        },
        // APPLICATION
        {
            name: 'app',
            path: '/',
            component: () => import('@/components/app/MainApp.vue')
        },
        {
            name: 'app-edit',
            path: '/edit/:id',
            component: () => import('@/components/app/MainApp.vue')
        },
        {
            name: 'app-tree',
            path: '/tree/:trid',
            component: () => import('@/components/app/MainApp.vue')
        },
        {
            name: 'app-tree-edit',
            path: '/tree/:trid/edit/:id',
            component: () => import('@/components/app/MainApp.vue')
        },
        // SETTINGS
        {
            path: '/preferences',
            component: () => import('@/components/app/settings/SettingsPage.vue')
        },
        {
            path: '/preferences/account',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'My Account',
                component: () => import('@/components/app/settings/pages/AccountPanel.vue')
            }
        },
        {
            path: '/preferences/keys',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'My Keys',
                component: () => import('@/components/app/settings/pages/KeysPanel.vue')
            }
        },
        {
            path: '/preferences/interface',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Interface',
                component: () => import('@/components/app/settings/pages/InterfacePanel.vue')
            }
        },
        {
            path: '/preferences/notifications',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Notifications',
                component: () => import('@/components/app/settings/pages/NotificationsPanel.vue')
            }
        },
        {
            path: '/preferences/devices',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Devices',
                component: () => import('@/components/app/settings/pages/DevicesPanel.vue')
            }
        },
        {
            path: '/preferences/io',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Import / Export',
                component: () => import('@/components/app/settings/pages/ImportExportPanels.vue')
            }
        },
        {
            path: '/preferences/passwords',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Passwords',
                component: () => import('@/components/app/settings/pages/PasswordsPanel.vue')
            }
        },
        {
            path: '/preferences/security',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Passwords',
                component: () => import('@/components/app/settings/pages/SecurityPanel.vue')
            }
        },
        {
            path: '/preferences/sharing',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Sharing',
                component: () => import('@/components/app/settings/pages/SharingPanel.vue')
            }
        },
        {
            path: '/preferences/organization',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'Organization',
                component: () => import('@/components/app/settings/pages/OrganizationPanel.vue')
            }
        },
        {
            path: '/preferences/about',
            component: () => import('@/components/app/settings/SettingsPage.vue'),
            props: {
                title: 'About Volt',
                component: () => import('@/components/app/settings/pages/AboutPanel.vue')
            }
        },
        // EXTERNAL
        {
            path: '/verify/:token',
            name: 'verify-email',
            component: () => import('@/components/pages/VerifyEmail.vue')
        },
        {
            path: '/share/:id/:key',
            name: 'share-external',
            component: () => import('@/components/pages/SharedEntry.vue')
        },
        // catch-all
        {
            path: '/*',
            redirect: '/'
        }
    ]
})

/**
 * Unlock and register guard
 */
router.beforeEach((to, from, next) => {
    // always allow externally linked paths
    if (to.name === 'verify-email' || to.name === 'share-external') {
        return next()
    }

    if (Locker.shouldRegister()) {
        if (to.name !== 'register' && to.name !== 'link') {
            return next('/register')
        }
    } else if (Locker.shouldUnlock() && to.name !== 'unlock') {
        return next('/unlock')
    }
    return next()
})

export class RouteBuilder {
    public static buildEditRoute(entryId?: string): string {
        const { params } = router.currentRoute
        let url = ''
        if (params.trid) {
            url += `/tree/${params.trid}`
        }
        if (entryId) {
            url += `/edit/${entryId}`
        }
        return url || '/'
    }

    public static buildTreeRoute(id?: string): string {
        const { params } = router.currentRoute
        let url = ''
        if (id) {
            url += `/tree/${id}`
        }
        if (params.id) {
            url += `/edit/${params.id}`
        }
        return url || '/'
    }

    public static setEditRoute(id?: string): void {
        router.push(this.buildEditRoute(id) as RawLocation)
    }

    public static setTreeRoute(id?: string): void {
        router.push(this.buildTreeRoute(id) as RawLocation)
    }

    public static getStateRoute(state: RootState): string {
        let url = ''
        if (state.entries.treeStack.length > 0) {
            const tree = state.entries.treeStack[state.entries.treeStack.length - 1]
            url += `/tree/${tree}`
        }
        if (state.editor.entry && state.editor.entry.id) {
            const { id } = state.editor.entry
            url += `/edit/${id}`
        }
        return url || '/'
    }
}
